(function () {
  'use strict';

  var root = document.documentElement;
  var body = document.body;
  var bar = document.querySelector('[data-amore-frame-bar]');
  var header = document.querySelector('[data-amore-frame-header]');
  var main = document.getElementById('MainContent');
  var canvas = document.querySelector('body > .shopify-section-group-header-group') || main;
  var homeHero = body.classList.contains('template-index') && main
    ? main.querySelector(':scope > .shopify-section:first-child')
    : null;
  var frameTick = false;
  var frameBarHeight = 60;
  var headerSection = document.querySelector('body > .section-header.shopify-section-group-header-group');

  function headerHeight() {
    return header ? header.getBoundingClientRect().height : 0;
  }

  function updateFrameGeometry() {
    frameTick = false;
    var measuredWindowWidth = document.documentElement.clientWidth;
    var measuredHeaderHeight = headerHeight();
    if (measuredWindowWidth) {
      root.style.setProperty('--amore-window-width', measuredWindowWidth + 'px');
    }
    if (canvas) {
      // Отступ считается от clientWidth, а НЕ от innerWidth. Поле применяется
      // к элементам `position: fixed` (шторка деталей, панель корзины), а их
      // система координат полосу прокрутки уже исключает. С innerWidth ширина
      // полосы учитывалась дважды, и правый слой вставал на 7px левее края
      // контента — ровно на столько шторка налезала на галерею после того,
      // как её ширину свели к 520 (замер 20.08 на 1281).
      var measuredCanvasRightOffset = Math.max(0, measuredWindowWidth - canvas.getBoundingClientRect().right);
      root.style.setProperty('--amore-canvas-right-offset', measuredCanvasRightOffset + 'px');
    }
    if (measuredHeaderHeight) {
      root.style.setProperty('--amore-header-height', measuredHeaderHeight.toFixed(3).replace(/\.?0+$/, '') + 'px');
      // FRAME-01: прячущий обработчик читает высоту отсюда, а не меряет её
      // сам на каждый кадр прокрутки.
      frameBarHeight = measuredHeaderHeight;
    }

    // Ширина полосы прокрутки запоминается, ПОКА полоса есть.
    // ВАЖНО: прежний текст здесь утверждал, что `scrollbar-gutter` от прыжка
    // не спасает и потому нужна компенсация полем. Это ОПРОВЕРГНУТО замером
    // 22.08 в настоящем режиме macOS «Всегда показывать полосы прокрутки»:
    // резерв держит, а компенсация поверх него давала сдвиг на ту же ширину
    // в обратную сторону. Числа и разбор — в `amore-frame.css` у правила
    // `scrollbar-gutter: stable`. Компенсации полем в CSS больше нет.
    // Переменная нужна по-прежнему: её читает `cart-drawer.drawer`
    // (`amore-cart.css:68`) — там такая же лишняя компенсация, наряд на её
    // снятие выдан владельцу той зоны.
    // PRV-01 (20.08.2026): гасителей прокрутки ДВА, и список здесь обязан
    // повторять селектор из amore-frame.css. Раньше проверялся только класс
    // Dawn, и шторка деталей (`amore-pdp-layer-open`) guard'ом не накрывалась:
    // любой scroll/resize при открытой шторке перезаписывал ширину нулём,
    // компенсация пропадала, правый столбец уезжал на 7 px, вордмарк на 3,5 px.
    // Замер 20.08 на 905 px — clientWidth 898 → 905.
    // 21.08: шторка гасит прокрутку ТОЛЬКО до 900. На десктопе полоса при
    // открытой шторке остаётся на месте, значит замер там верен и запрещать
    // его нельзя — иначе ширина замрёт на старом значении. Порог тот же, что
    // в медиазапросах amore-pdp.css и amore-frame.css.
    var sheetLocksScroll = window.matchMedia('(max-width: 899px)').matches;
    if (!body.classList.contains('overflow-hidden') &&
        !(sheetLocksScroll && body.classList.contains('amore-pdp-layer-open'))) {
      var measuredScrollbar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      root.style.setProperty('--amore-scrollbar-width', measuredScrollbar + 'px');
    }

    if (homeHero) {
      var heroRect = homeHero.getBoundingClientRect();
      // FRAME-09 п.1: гистерезис вокруг порога heroRect.bottom <=
      // measuredHeaderHeight, тем же приёмом и ТОЙ ЖЕ величиной, что у
      // прятания шапки (FRAME_HIDE_DEADZONE=8, ниже в этом файле — не
      // подбирается заново). Порог раньше был одноточечным: на пороге
      // при дрожащем скролле класс мог переключаться туда-обратно на
      // каждом кадре, и цвет `.amore-frame-bar` (значит и валюты,
      // наследующей color) срывался вместе с ним — сама плавность цвета
      // чинит transition в amore-frame.css:217, мёртвая зона здесь не
      // даёт классу дёргаться по нескольку раз на одном и том же
      // дрожании у границы (FRAME-08 recon вопрос 2).
      var heroPassed = body.classList.contains('amore-home-hero-passed');
      if (heroPassed) {
        if (heroRect.bottom > measuredHeaderHeight + FRAME_HIDE_DEADZONE) {
          heroPassed = false;
        }
      } else if (heroRect.bottom <= measuredHeaderHeight - FRAME_HIDE_DEADZONE) {
        heroPassed = true;
      }
      body.classList.toggle('amore-home-hero-passed', heroPassed);
    }
  }

  function scheduleFrameGeometry() {
    if (frameTick) return;
    frameTick = true;
    // R-04: прятание полосы решается тем же проходом rAF, СРАЗУ после
    // updateFrameGeometry — та пишет amore-home-hero-passed, а решение
    // о прятании читает этот класс через frameHideBlocked(). Раздельные
    // слушатели `scroll` гоняли эти две функции независимо: геометрия —
    // отложенно через rAF, прятание — синхронно в момент события, и
    // синхronный обработчик успевал прочитать класс раньше, чем rAF
    // его записывал. Отдельного слушателя для updateFrameVisibility
    // больше нет — см. FRAME-01 §2 ниже.
    window.requestAnimationFrame(function () {
      updateFrameGeometry();
      updateFrameVisibility();
    });
  }

  window.addEventListener('resize', scheduleFrameGeometry);
  window.addEventListener('orientationchange', scheduleFrameGeometry);
  window.addEventListener('scroll', scheduleFrameGeometry, { passive: true });

  if ('ResizeObserver' in window) {
    var frameResizeObserver = new ResizeObserver(scheduleFrameGeometry);
    if (bar) frameResizeObserver.observe(bar);
    if (homeHero) frameResizeObserver.observe(homeHero);
  }

  if ('MutationObserver' in window) {
    var frameClassObserver = new MutationObserver(scheduleFrameGeometry);
    frameClassObserver.observe(body, { attributes: true, attributeFilter: ['class'] });
  }

  updateFrameGeometry();

  /* ============ ЧЕМ ЧЕЛОВЕК ПОЛЬЗУЕТСЯ ПРЯМО СЕЙЧАС ==================
     Все слои рамы возвращают фокус на свой триггер программно, и это
     правильно — иначе клавиатура после закрытия панели теряет место:
       панель корзины  — cart-drawer.js:52 → removeTrapFocus → global.js:141
       шторка деталей  — amore-pdp.js:305 `lastDrawerTrigger.focus()`
       мега-меню       — megaClose(true) ниже в этом файле
       выдвижное меню  — closeMenu() + menuOpen.focus()
       панель поиска   — global.js:453 removeTrapFocus(summary)

     Chromium после такого возврата рамку `:focus-visible` не рисует, если
     закрывали мышью; Safari рисует — эвристики у них разные, и спор этот
     разрешить со стороны страницы нечем. Поэтому запоминаем, ЧЕМ человек
     работал последним, и гасим рамку только на самих триггерах и только
     в мышином режиме (правила в amore-frame.css).

     Порядок событий делает это безопасным: Tab — тоже keydown, и он
     приходит РАНЬШЕ, чем фокус переедет, поэтому клавиатурный обход
     рамку не теряет никогда. Esc — тоже keydown, поэтому закрытие с
     клавиатуры оставляет рамку на месте. Стартовое значение —
     `keyboard`: пока не доказано обратное, рамку показываем.

     Стоковое правило Dawn `*:focus-visible` (base.css:758) не трогаем:
     оно держит клавиатурную навигацию во всех панелях сразу. */
  function markInputMode(mode) {
    if (root.getAttribute('data-amore-input') !== mode) root.setAttribute('data-amore-input', mode);
  }
  markInputMode('keyboard');
  document.addEventListener('pointerdown', function () { markInputMode('pointer'); }, true);
  document.addEventListener('keydown', function () { markInputMode('keyboard'); }, true);

  /* ============ FRAME-04: ШТАМП МОДАЛЬНОСТИ НА САМОМ УЗЛЕ =============
     Флага на `<html>` мало: он глобальный и меняется во времени, а фокус
     на триггере остаётся. Замер 22.08 (Chrome 151 и Safari 26.5.2, шесть
     путей закрытия, настоящий ввод): сразу после закрытия МЫШЬЮ флаг
     `pointer` и кольца нет — но ПЕРВОЕ ЖЕ нажатие любой клавиши ставит
     `keyboard`, правило перестаёт совпадать, и кольцо проявляется на всё
     ещё сфокусированной ссылке. Покупателю достаточно прокрутить страницу
     стрелкой или пробелом. В Safari хуже: там `:focus-visible` на ссылке
     истинно уже сразу после мышиного закрытия, и кольцо держит один
     только флаг.

     Поэтому модальность СНИМАЕТСЯ В МОМЕНТ ПОЛУЧЕНИЯ ФОКУСА и остаётся
     на узле, пока фокус не переехал. `focusin` приходит ПОСЛЕ
     `pointerdown` и ПОСЛЕ `keydown` (проверено журналом событий), то есть
     к моменту штампа флаг уже верный.

     Штамп ПЕРЕПИСЫВАЕТСЯ при каждом новом `focusin` на узле — это
     обязательное условие: иначе ссылка, один раз закрытая мышью, навсегда
     перестала бы показывать кольцо клавиатурному покупателю, и правка
     доступности превратилась бы в дефект доступности. Сценарий проверки:
     закрыть мышью → уйти Tab → вернуться Shift+Tab → кольцо есть.

     Список узлов ровно тот же, что в правилах `amore-frame.css` — оба
     держим в одном месте, чтобы половина триггеров не осталась на старом
     механизме. Правка FRAME-03 (`base.css:802`, контейнеры с
     `tabindex="-1"`) сюда не относится: там механизм другой.

     SEARCH-02 §3.1: тем же штампом закрыты ещё два узла, но по ДРУГОЙ
     причине — не возврат фокуса после слоя, а прямое касание. Поле поиска
     и поле рассылки в подвале получили кольцо `:focus-visible` сегодня
     (FRAME-07), и то же расхождение движков: с клавиатуры кольцо нужно
     всегда, с пальца/мыши — эвристика `:focus-visible` в Safari отдаёт
     истину сразу на касании. Механизм штампа безразличен к тому, почему
     пришёл фокус, поэтому список просто расширен, а не продублирован. */
  var AMORE_FOCUS_TRIGGERS = [
    '#cart-icon-bubble',
    '.amore-frame-nav-item > a',
    '[data-amore-menu-open]',
    '.amore-frame-search__toggle',
    '[data-amore-pdp-details-open]',
    '.amore-frame-search-form .search__input',
    '#AmoreFrameFooterEmail',
    '[data-amore-search-word-open]'
  ].join(',');

  document.addEventListener('focusin', function (event) {
    var node = event.target;
    if (!node || typeof node.matches !== 'function') return;
    if (!node.matches(AMORE_FOCUS_TRIGGERS)) return;
    node.setAttribute('data-amore-focus-mode', root.getAttribute('data-amore-input') || 'keyboard');
  }, true);

  /* ============ FRAME-06: ПОДЛОЖКА ЛИСТАЕТСЯ НА ДЕСКТОПЕ ==============
     Решение владельца 22.08: на десктопе страница под открытым слоем
     листается, на телефоне блокировка остаётся — панель там во весь экран.
     Порог 900 — тот же, где 520 уступает мобильной форме
     (`amore-cart.css:1338`, `amore-pdp.css:498`, `amore-frame.css:153`),
     новый не заводим.

     Касается ДВУХ слоёв из четырёх. Замер 22.08, четыре ширины, оба
     браузера, настоящий ввод: шторка размеров гасит прокрутку только
     до 899 и на десктопе уже листается, мега-меню не гасит вовсе
     (на `body` идёт `amore-mega-on`, не `overflow-hidden`). Менять надо
     панель корзины и панель поиска — они гасят на ВСЕХ ширинах.

     Класс ставим свой, а не читаем чужой: снимать блокировку по голому
     `.overflow-hidden` нельзя — тот же класс вешают модалка галереи
     товара (`global.js:554`) и панель самовывоза
     (`pickup-availability.js:112`), это полноэкранные слои, им блокировка
     нужна.

     Состояния наблюдаем СНАРУЖИ, по атрибутам: у корзины — класс `active`
     на `<cart-drawer>`, у поиска — атрибут `open` на родительском
     `<details>` (собственного класса у панели нет, проверено разметкой в
     обоих состояниях). Чужой JS не трогаем: ни `cart-drawer.js`,
     ни `global.js`.

     `:has()` намеренно не используется: он работает, но его поведение
     пришлось бы перепроверять при каждой следующей правке шапки, а явный
     класс — один источник истины.

     Имена с приставкой `amoreLayer` намеренно: ниже по файлу уже объявлены
     `searchDetails` и `cartDrawer`, а `var` в пределах одной функции — это
     одна и та же переменная; без приставки моё значение переписалось бы
     там при выполнении. */
  var LAYER_SCROLLABLE = 'amore-layer-scrollable';
  var amoreLayerCart = document.querySelector('cart-drawer');
  var amoreLayerSearchToggle = document.querySelector('.amore-frame-search__toggle');
  var amoreLayerSearchDetails = amoreLayerSearchToggle && amoreLayerSearchToggle.closest ? amoreLayerSearchToggle.closest('details') : null;

  function syncLayerScrollable() {
    var cartOpen = !!(amoreLayerCart && amoreLayerCart.classList.contains('active'));
    var searchOpen = !!(amoreLayerSearchDetails && amoreLayerSearchDetails.hasAttribute('open'));
    body.classList.toggle(LAYER_SCROLLABLE, cartOpen || searchOpen);
  }

  syncLayerScrollable();
  if ('MutationObserver' in window) {
    if (amoreLayerCart) {
      new MutationObserver(syncLayerScrollable)
        .observe(amoreLayerCart, { attributes: true, attributeFilter: ['class'] });
    }
    if (amoreLayerSearchDetails) {
      new MutationObserver(syncLayerScrollable)
        .observe(amoreLayerSearchDetails, { attributes: true, attributeFilter: ['open'] });
    }
  }

  var menu = document.getElementById('AmoreFrameMenu');
  var menuOpen = document.querySelector('[data-amore-menu-open]');
  var menuClose = document.querySelector('[data-amore-menu-close]');

  function closeMenu() {
    if (!menu || !menuOpen) return;
    menu.hidden = true;
    menu.setAttribute('aria-hidden', 'true');
    menuOpen.setAttribute('aria-expanded', 'false');
    body.classList.remove('overflow-hidden');
    // FRAME-09 п.3: свой класс, не общий `.overflow-hidden` (тот же класс
    // вешают и другие слои — см. комментарий у FRAME_HIDE_DEADZONE ниже,
    // "класс ставим свой, а не читаем чужой"). CSS по этому классу прячет
    // бургер/лупу/валюту/сумку в шапке (amore-frame.css, мобильный блок
    // рядом с .amore-frame-mobile-menu).
    body.classList.remove('amore-mobile-menu-open');
    syncScrim();
  }

  /* FRAME-13, симптом владельца 14.09: крестик должен вставать РОВНО на
     место бургера, а не по отдельно подобранному числу. Бургер (шапка,
     align-items:baseline, FIX-02/FIX-03) и крестик (`.amore-frame-mobile-
     menu__top`, align-items:center) — два независимых механизма
     выравнивания, и прежняя правка (FRAME-09/11) компенсировала разрыв
     между ними константой -7.5px, замеренной один раз. Любая следующая
     правка ЛЮБОГО из двух механизмов развела бы линии снова тем же путём.
     Вместо константы — живой замер здесь, в момент открытия:
       1. Бокс бургера снят ДО того, как его скрывает
          `body.amore-mobile-menu-open .amore-frame-header__left`
          (amore-frame.css) — единственный момент, когда он измерим.
       2. Панель делается видимой, `--amore-menu-close-shift` сначала
          снимается — иначе замер бокса крестика унаследует смещение от
          ПРЕДЫДУЩЕГО открытия и разница задвоится.
       3. Бокс крестика снят в этом чистом (несмещённом) состоянии.
       4. Разница центров двух боксов пишется в `--amore-menu-close-shift`
          на самом узле крестика; CSS (`.amore-frame-mobile-menu__top
          [data-amore-menu-close]`) читает переменную как `top`. */
  function openMenu() {
    if (!menu || !menuOpen) return;
    var burgerRect = menuOpen.getBoundingClientRect();
    menu.hidden = false;
    menu.setAttribute('aria-hidden', 'false');
    if (menuClose && burgerRect.height) {
      menuClose.style.removeProperty('--amore-menu-close-shift');
      var closeRect = menuClose.getBoundingClientRect();
      if (closeRect.height) {
        var shift = (burgerRect.top + burgerRect.height / 2) - (closeRect.top + closeRect.height / 2);
        menuClose.style.setProperty('--amore-menu-close-shift', shift.toFixed(3) + 'px');
      }
    }
    menuOpen.setAttribute('aria-expanded', 'true');
    body.classList.add('overflow-hidden');
    body.classList.add('amore-mobile-menu-open');
    if (menuClose) menuClose.focus();
    syncScrim();
  }

  if (menuOpen) menuOpen.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);

  document.querySelectorAll('[data-amore-menu-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var selected = tab.getAttribute('data-amore-menu-tab');
      document.querySelectorAll('[data-amore-menu-tab]').forEach(function (candidate) {
        candidate.setAttribute('aria-selected', String(candidate === tab));
      });
      document.querySelectorAll('[data-amore-menu-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-amore-menu-panel') !== selected;
      });

      /* FRAME-11, симптом владельца 12.09: пульс по нажатию плюс волна
         открытия, скопировать механику Toteme. Пульс — перезапуск CSS-
         анимации через reflow (`void tab.offsetWidth`), тот же приём, что
         уже стоит в теме для повторных анимаций (см. amore-scrim). Волна —
         класс ставится на панель В СЛЕДУЮЩЕМ кадре: панель только что
         получила `hidden = false` в этом же тике, а свойство `hidden`
         снимает `display:none` синхронно, но браузер должен успеть
         посчитать раскладку до старта анимации, иначе clip-path стартует
         уже в конечном состоянии и волны не видно. */
      tab.classList.remove('amore-menu-tab-pulsing');
      void tab.offsetWidth;
      tab.classList.add('amore-menu-tab-pulsing');

      var activePanel = document.querySelector('[data-amore-menu-panel="' + selected + '"]');
      if (activePanel) {
        activePanel.classList.remove('amore-menu-panel-revealing');
        window.requestAnimationFrame(function () {
          activePanel.classList.add('amore-menu-panel-revealing');
        });
      }
    });
  });

  /* ============ МЕГА-МЕНЮ (NAV-01 §2) =================================
     Две панели наведения — Shop и About. Открытие МГНОВЕННОЕ: таймера на
     открытие нет вовсе, а переход входа снят в CSS (`.is-open` несёт
     `transition: none`). Прежние 140 мс отменены решением владельца.
     Таймер стоит только на ЗАКРЫТИЕ: без него панель схлопывается, пока
     курсор идёт от слова к панели через пустоту, и до кадров не добраться.
     Открытие одной гасит вторую: две раскрытые панели физически не
     помещаются и перекрывают друг друга.
     Меню живёт только на десктопе — на телефоне те же пункты лежат в
     выдвижном меню рамы, и открывается оно нажатием. */
  var MEGA_CLOSE_DELAY = 260;
  var megaPanels = {};
  var megaTriggers = {};
  var megaDesktop = window.matchMedia('(min-width: 900px)');
  var megaCloseTimer = 0;
  var megaKey = null;

  document.querySelectorAll('[data-amore-mega-panel]').forEach(function (panel) {
    megaPanels[panel.getAttribute('data-amore-mega-panel')] = panel;
  });
  document.querySelectorAll('[data-amore-mega-trigger]').forEach(function (trigger) {
    megaTriggers[trigger.getAttribute('data-amore-mega-trigger')] = trigger;
  });

  function megaOwns(node) {
    if (!node || !megaKey) return false;
    var trigger = megaTriggers[megaKey];
    var panel = megaPanels[megaKey];
    return !!((trigger && trigger.contains(node)) || (panel && panel.contains(node)));
  }

  function megaSyncState() {
    Object.keys(megaTriggers).forEach(function (key) {
      var open = key === megaKey;
      var link = megaTriggers[key].querySelector('a');
      var panel = megaPanels[key];
      if (link) link.setAttribute('aria-expanded', String(open));
      if (panel) {
        panel.classList.toggle('is-open', open);
        panel.setAttribute('aria-hidden', String(!open));
      }
    });
    body.classList.toggle('amore-mega-on', !!megaKey);
    syncScrim();
  }

  /* Кадр справа — ровно один на экране. Пункт без кадра гасит область
     целиком: пустой рамки на его месте быть не должно. */
  function megaShowFigure(panel, key) {
    if (!panel) return;
    panel.querySelectorAll('[data-amore-mega-figure]').forEach(function (figure) {
      figure.classList.toggle('is-active', figure.getAttribute('data-amore-mega-figure') === key);
    });
  }

  /* Кадр, показанный СРАЗУ при открытии, обязан принадлежать пункту, который
     в этот момент виден. Поэтому кандидатов ищем только в первом столбце:
     категории лежат за `By category` и на открытии скрыты, и кадр `Tops`
     с подписью «Tops» при курсоре где-то над словом `Shop` говорил бы
     неправду. Пока владелец не поставил кадры Wardrobe / The Amore Set /
     Made to measure, кандидата нет — область остаётся пустой до наведения,
     пустой рамки в ней не появляется. Поставит — кадр подхватится сам. */
  function megaDefaultFigure(panel) {
    if (!panel) return;
    var column = panel.querySelector('.amore-mega__col');
    var candidates = column ? column.querySelectorAll('[data-amore-mega-item]') : [];
    for (var i = 0; i < candidates.length; i++) {
      var key = candidates[i].getAttribute('data-amore-mega-item');
      if (panel.querySelector('[data-amore-mega-figure="' + key + '"]')) {
        megaShowFigure(panel, key);
        return;
      }
    }
    megaShowFigure(panel, null);
  }

  function megaOpen(key, moveFocus) {
    if (!megaDesktop.matches || !megaPanels[key]) return;
    window.clearTimeout(megaCloseTimer);
    if (megaKey !== key) {
      megaKey = key;
      megaSyncState();
      megaDefaultFigure(megaPanels[key]);
    }
    if (moveFocus) {
      var first = megaPanels[key].querySelector('a[href], button');
      if (first) first.focus();
    }
  }

  function megaClose(returnFocus) {
    window.clearTimeout(megaCloseTimer);
    if (!megaKey) return false;
    var previous = megaKey;
    megaKey = null;
    megaSyncState();
    if (returnFocus && megaTriggers[previous]) {
      var link = megaTriggers[previous].querySelector('a');
      if (link) link.focus();
    }
    return true;
  }

  function megaScheduleClose() {
    window.clearTimeout(megaCloseTimer);
    megaCloseTimer = window.setTimeout(function () {
      var trigger = megaKey ? megaTriggers[megaKey] : null;
      var panel = megaKey ? megaPanels[megaKey] : null;
      if (trigger && trigger.matches(':hover')) return;
      if (panel && panel.matches(':hover')) return;
      if (megaOwns(document.activeElement)) return;
      megaClose(false);
    }, MEGA_CLOSE_DELAY);
  }

  Object.keys(megaTriggers).forEach(function (key) {
    var trigger = megaTriggers[key];
    var panel = megaPanels[key];
    var link = trigger.querySelector('a');

    [trigger, panel].forEach(function (node) {
      if (!node) return;
      node.addEventListener('mouseenter', function () { megaOpen(key, false); });
      node.addEventListener('mouseleave', megaScheduleClose);
      /* Фокус САМ по себе панель не раскрывает: по постановке Tab доводит
         до пункта, а открывает стрелка вниз. Здесь фокус только держит
         открытое открытым, пока курсор уже ушёл. */
      node.addEventListener('focusin', function () { window.clearTimeout(megaCloseTimer); });
      node.addEventListener('focusout', function (event) {
        if (!megaOwns(event.relatedTarget)) megaScheduleClose();
      });
    });

    if (link) {
      link.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        megaOpen(key, true);
      });
    }

    if (panel) {
      panel.querySelectorAll('[data-amore-mega-item]').forEach(function (item) {
        var figureKey = item.getAttribute('data-amore-mega-item');
        item.addEventListener('mouseenter', function () { megaShowFigure(panel, figureKey); });
        item.addEventListener('focus', function () { megaShowFigure(panel, figureKey); });
      });
    }
  });

  /* Прокрутка закрывает панель СРАЗУ, без задержки закрытия: человек уже
     ушёл со страницы вверх или вниз, ждать его возвращения незачем. */
  window.addEventListener('scroll', function () {
    if (!megaKey) return;
    megaClose(false);
    /* FRAME-01: этот жест прокрутки ЗАКРЫЛ меню — он же не должен ещё и
       увести полосу. Сдвигаем точку отсчёта прячущего обработчика на
       текущее положение: он увидит нулевое смещение и оставит полосу на
       месте. Полоса уедет со следующего движения, когда меню уже закрыто. */
    frameLastScrollY = Math.max(0, window.pageYOffset);
  }, { passive: true });

  megaDesktop.addEventListener('change', function (event) {
    if (!event.matches) megaClose(false);
  });

  /* Мобильные категории раскрываются нажатием — наведения на телефоне нет. */
  var mobileCatsButton = document.querySelector('[data-amore-mobile-cats]');
  if (mobileCatsButton) {
    var mobileCatsList = document.getElementById('AmoreFrameMobileCats');
    mobileCatsButton.addEventListener('click', function () {
      var open = mobileCatsButton.getAttribute('aria-expanded') === 'true';
      mobileCatsButton.setAttribute('aria-expanded', String(!open));
      if (mobileCatsList) mobileCatsList.hidden = open;
    });
  }

  /* ============ ВУАЛЬ =================================================
     Один элемент на все слои (layout/theme.liquid, правила в
     amore-frame.css). Прототип включает вуаль одной строкой сразу для пяти
     состояний (:711); здесь то же самое собрано из четырёх источников,
     потому что слои в теме принадлежат разным компонентам:
       меню            — свой флаг `menu.hidden`;
       поиск           — `<details open>`;
       шторка деталей  — класс `body.amore-pdp-layer-open` + событие
                         `amore:layer` из amore-pdp.js;
       панель корзины  — класс `active` на `cart-drawer` (ставит Dawn).
     Крестики слоёв остаются на месте, вуаль — второй способ закрыть. */
  var scrim = document.querySelector('[data-amore-scrim]');
  var searchDetails = document.querySelector('.amore-frame-search details');
  var cartDrawer = document.querySelector('cart-drawer');

  function layerState() {
    return {
      menu: !!(menu && !menu.hidden),
      search: !!(searchDetails && searchDetails.open),
      sheet: body.classList.contains('amore-pdp-layer-open'),
      cart: !!(cartDrawer && cartDrawer.classList.contains('active')),
      mega: !!megaKey
    };
  }

  function syncScrim() {
    if (!scrim) return;
    var state = layerState();
    var open = state.menu || state.search || state.sheet || state.cart || state.mega;
    body.classList.toggle('amore-scrim-on', open);
    // FRAME-07: бумажную вуаль (прототип :1420) получают ОБА боковых слоя —
    // корзина и поиск. Класс назван по материалу, а не по слою: до 22.08 он
    // звался `--cart`, и поиск оставался на общей вуали в 6% чернил, из-за
    // чего подложка под ним не притемнялась вовсе.
    body.classList.toggle('amore-scrim-on--paper', state.cart || state.search);
  }

  /* Закрываем ОДИН слой — верхний. Порядок повторяет порядок наложения:
     панель корзины (z 1000), поиск (83), шторка деталей (80), мега-меню
     (шапка поднимается до 75), выдвижное меню. */
  function closeTopLayer() {
    var state = layerState();
    if (state.cart && cartDrawer) {
      var cartClose = cartDrawer.querySelector('.drawer__close');
      if (cartClose) cartClose.click();
      else if (typeof cartDrawer.close === 'function') cartDrawer.close();
      return true;
    }
    if (state.search && searchDetails) {
      searchDetails.open = false;
      syncScrim();
      return true;
    }
    if (state.sheet) {
      var sheetClose = document.querySelector('[data-amore-pdp-details-close]');
      if (sheetClose) sheetClose.click();
      return true;
    }
    if (state.mega) {
      megaClose(true);
      return true;
    }
    if (state.menu) {
      closeMenu();
      if (menuOpen) menuOpen.focus();
      return true;
    }
    return false;
  }

  if (scrim) scrim.addEventListener('click', closeTopLayer);
  document.addEventListener('amore:layer', syncScrim);
  if (searchDetails) searchDetails.addEventListener('toggle', syncScrim);

  /* ============ SEARCH-03 §1: СЛОВЕСНАЯ КНОПКА НА ДЕСКТОПЕ ============
     Панель и её открытие/закрытие держатся целиком на родной `<summary>`
     (`details-modal.js`, чужой файл, не трогаем). На ≥900 она скрыта
     (`amore-frame.css`), а видимую словесную кнопку в правой группе
     заводить вторым `<predictive-search>` не стали — риск коллизии id
     (`AmoreFrameSearchInput`, `predictive-search-results`) перевешивает
     выгоду от «настоящей» второй summary. Кнопка просто кликает родную —
     это триггерит весь путь `details-modal.js` как от настоящего клика:
     trapFocus, блокировку прокрутки, закрытие по клику вовне.
     Enter/Space на `<button>` уже открывают её — родное поведение кнопки,
     доп. JS не нужен. */
  var searchWordToggle = document.querySelector('[data-amore-search-word-open]');
  if (searchWordToggle && searchDetails) {
    var searchSummaryToggle = searchDetails.querySelector('summary');
    if (searchSummaryToggle) {
      searchWordToggle.addEventListener('click', function () {
        searchSummaryToggle.click();
      });

      /* `details-modal.js:40` при закрытии возвращает фокус на СВОЙ
         summary (`removeTrapFocus(focusToggle ? this.summaryToggle : null)`).
         На десктопе эта summary `display:none`, `.focus()` на ней — no-op
         по спеке, и фокус проваливается на `<body>`. Подбираем его на
         видимую словесную кнопку, но только когда фокус ДЕЙСТВИТЕЛЬНО
         потерян — на телефоне summary видима и сама ловит фокус штатно,
         это условие там просто не выполнится. */
      searchDetails.addEventListener('toggle', function () {
        if (searchDetails.hasAttribute('open')) return;
        if (document.activeElement === document.body &&
            getComputedStyle(searchWordToggle).display !== 'none') {
          searchWordToggle.focus();
        }
      });
    }
  }
  if (cartDrawer) {
    new MutationObserver(syncScrim).observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  syncScrim();

  /* ============ ПРЯТАНИЕ ПОЛОСЫ ПРИ ПРОКРУТКЕ (FRAME-01 §2) ==========
     Вниз — полоса уезжает, вверх — возвращается, у самого верха всегда
     видима. Двигает её CSS (`body.amore-frame-hidden` → `top` липкой
     обёртки); здесь только решение, когда этот класс ставить.

     ПОРОГИ:
       8 px — мёртвая зона. Дрожание пальца на трекпаде не должно дёргать
       полосу; накопление идёт до тех пор, пока смещение не превысит порог,
       поэтому медленная прокрутка не теряется.
       Высота полосы — второй порог: пока страница отмотана меньше, чем на
       её собственную высоту, прятать нечего.
       Вверх порога высоты НЕТ: этим движением человек тянется к меню.

     КОГДА ПРЯТАТЬ НЕЛЬЗЯ — состояние замораживается, а не сбрасывается:
     принудительный показ был бы таким же скачком, как уход. */
  var FRAME_HIDE_DEADZONE = 8;
  var frameLastScrollY = Math.max(0, window.pageYOffset);
  var frameHidden = false;
  var catalogFilterSelector = '[data-amore-mobile-filter]:not([hidden]), [data-amore-desktop-filter]:not([hidden])';

  function frameHideBlocked() {
    // Мега-меню раскрыто.
    if (megaKey) return true;
    // Панель корзины, панель поиска, шторка деталей, выдвижное меню рамы.
    var state = layerState();
    if (state.cart || state.search || state.sheet || state.menu) return true;
    // Шторка фильтра каталога — читаем её собственную разметку, своего
    // класса на body она не ставит (amore-catalog.js:61-68).
    if (document.querySelector(catalogFilterSelector)) return true;
    // Фокус клавиатуры внутри шапки: уехавшая полоса увела бы фокус за экран.
    var active = document.activeElement;
    if (active && active !== body && headerSection && headerSection.contains(active)) return true;
    // ГЛАВНАЯ, пока виден первый экран: полоса прозрачная и стоит на месте —
    // она и так наверху. Класс ставит updateFrameGeometry, новый не заводим.
    if (body.classList.contains('template-index') && !body.classList.contains('amore-home-hero-passed')) return true;
    return false;
  }

  function setFrameHidden(next) {
    if (next === frameHidden) return;
    frameHidden = next;
    body.classList.toggle('amore-frame-hidden', next);
  }

  function updateFrameVisibility() {
    var y = Math.max(0, window.pageYOffset);
    var delta = y - frameLastScrollY;
    if (Math.abs(delta) < FRAME_HIDE_DEADZONE) return;
    frameLastScrollY = y;
    if (y <= frameBarHeight) { setFrameHidden(false); return; }
    if (frameHideBlocked()) return;
    if (delta < 0) { setFrameHidden(false); return; }
    setFrameHidden(true);
  }

  /* Отдельного `scroll`-слушателя здесь больше нет — решение о прятании
     принимается внутри rAF-прохода updateFrameGeometry/scheduleFrameGeometry
     (см. R-04 у неё), сразу после записи amore-home-hero-passed. */
  /* Слой мог закрыться, пока полоса стояла замороженной: пересчитываем
     от текущего положения, чтобы следующий жест считался от него. */
  document.addEventListener('amore:layer', function () { frameLastScrollY = Math.max(0, window.pageYOffset); });
  updateFrameVisibility();

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeTopLayer();
  });

  window.matchMedia('(min-width: 900px)').addEventListener('change', function (event) {
    if (event.matches) closeMenu();
  });

  /* ============ R03: ПОЛЕ ПОИСКА НА ТЕЛЕФОНЕ ===========================
     Три правки, все за забором `searchMobile.matches` (<900) — десктопная
     панель, `predictive-search.js` и `base.css` вне наряда, поведение там
     не меняется ни на йоту. Разбор геометрии и происхождения бага —
     в `amore-frame.css` (§1 залитое поле, §2 крестик) и ниже (§3 Done). */
  var searchPanelContent = document.querySelector('.amore-frame-search-panel__content');
  var searchClearCloseBtn = document.querySelector('[data-amore-search-clear-close]');
  var searchResetBtn = document.querySelector('.amore-frame-search-form button[type="reset"]');
  var searchInputEl = document.querySelector('.amore-frame-search-form .search__input');
  var searchMobile = window.matchMedia('(max-width: 899px)');

  /* §2а. Родной `button[type=reset]` остаётся в DOM (нужен `search-form.js`
     — см. разбор в CSS), визуально скрыт и снят с Tab-обхода СВОИМ
     отдельным флагом, не завязанным на либу: класс/`tabindex`/
     `aria-hidden` ставит и снимает только этот код.
     SEARCH-08: было условно, только на телефоне (`searchMobile.matches`) —
     на десктопе кнопка оставалась обычной, второй видимый крестик рядом
     с полем (владелец: «второй крестик под первым»). Условие снято,
     приглушение теперь безусловное на обеих ширинах — класс
     `.amore-frame-search-reset--muted` сам по себе ничего не рисует,
     видимый эффект даёт CSS-правило под тем же классом, а оно как было
     заперто в `@media (max-width: 899px)`, так и осталось (не трогалось),
     плюс с SEARCH-08 появился зеркальный десктопный вариант того же
     правила (`amore-frame.css`, `@media (min-width: 900px)`) — значит
     мобильный результат этой функции не меняется ни на пиксель (mobile
     и раньше получал true), меняется только десктопный. */
  function syncSearchResetVisibility() {
    if (!searchResetBtn) return;
    searchResetBtn.classList.add('amore-frame-search-reset--muted');
    searchResetBtn.setAttribute('tabindex', '-1');
    searchResetBtn.setAttribute('aria-hidden', 'true');
  }
  syncSearchResetVisibility();

  /* Подпись кнопки следует за тем, что она СЕЙЧАС сделает: очистит (есть
     текст) или закроет (поле пустое) — обе подписи уже переведены в
     разметке (`data-amore-close-label`/`data-amore-clear-label`), здесь
     только переключение. На десктопе кнопка всегда «Close» — поведение
     там не меняется, подпись тоже. */
  function syncSearchCloseLabel() {
    if (!searchClearCloseBtn || !searchInputEl) return;
    var clearing = searchMobile.matches && searchInputEl.value.length > 0;
    var label = clearing
      ? searchClearCloseBtn.getAttribute('data-amore-clear-label')
      : searchClearCloseBtn.getAttribute('data-amore-close-label');
    if (label) searchClearCloseBtn.setAttribute('aria-label', label);
  }
  syncSearchCloseLabel();
  if (searchInputEl) searchInputEl.addEventListener('input', syncSearchCloseLabel);
  if (searchDetails) searchDetails.addEventListener('toggle', syncSearchCloseLabel);

  /* §2б. ОДИН КРЕСТИК — поведение. Слушатель — на РОДИТЕЛЕ кнопки
     (`.amore-frame-search-panel__content`), не на самой кнопке: у кнопки
     уже висит чужой bubble-слушатель `details-modal.js` (`close()`,
     подключён через `querySelector('button[type="button"]')` при апгрейде
     кастом-элемента — обычно раньше, чем выполнится этот файл). На одном
     узле порядок двух bubble-слушателей решает порядок ПОДКЛЮЧЕНИЯ, и
     `capture:true` на самой кнопке это не обходит: в AT_TARGET-фазе
     capture- и bubble-слушатели идут в порядке регистрации, а не капчура
     раньше бабла. На РОДИТЕЛЕ `capture:true` — другое дело: событие идёт
     туда ДО того, как вообще доберётся до кнопки, поэтому порядок
     регистрации чужого файла больше не важен.
     Пусто → ничего не делаем, событие идёт дальше своим ходом — это и есть
     штатное закрытие всей панели (правило работало так и до наряда). */
  if (searchPanelContent && searchClearCloseBtn && searchInputEl) {
    searchPanelContent.addEventListener('click', function (event) {
      if (!searchMobile.matches) return;
      var target = event.target;
      var onCloseBtn = target === searchClearCloseBtn ||
        (target.closest && target.closest('[data-amore-search-clear-close]') === searchClearCloseBtn);
      if (!onCloseBtn) return;
      if (!searchInputEl.value.length) return;
      event.stopPropagation();
      event.preventDefault();
      /* Очистка идёт ЧЕРЕЗ родную кнопку сброса, не присвоением `.value`
         напрямую: клик по `button[type=reset]` бросает настоящее DOM-
         событие `reset` на форму, которое слушает `search-form.js`
         (`onFormReset` → `PredictiveSearch.onFormReset` → abort старого
         запроса, `closeResults(true)`, возврат фокуса в поле) — это тот
         же путь, что был у видимого родного крестика раньше, просто
         кнопка теперь спрятана, а не убрана. */
      if (searchResetBtn) searchResetBtn.click();
      else { searchInputEl.value = ''; searchInputEl.focus(); }
      syncSearchCloseLabel();
    }, true);
  }

  /* §3. DONE НЕ ГАСИТ ПОДСКАЗКИ. `predictive-search.js` рвёт результаты
     по `focusout`, если новый `document.activeElement` не внутри
     `<predictive-search>` (`this.contains(document.activeElement)`) — а
     после тапа по галочке/Done экранной клавиатуры фокус уезжает на
     `<body>` без выбора покупателем какого-либо элемента: `relatedTarget`
     в этом случае пуст (замер 25.08: `blur()` поля → activeElement
     становится `body`, панель поиска остаётся `open`, поле не пустое —
     ровно так и рвались подсказки). НАСТОЯЩИЙ уход фокуса (Tab на
     следующий реальный элемент) всегда называет его в `relatedTarget` —
     этим и отличаем два случая: только пустой/`body`-релатедТаргет гасим.
     Родитель — тот же `.amore-frame-search-panel__content`, `<predictive-
     search>` лежит внутри него (см. разметку в `amore-frame-header.liquid`)
     — `capture:true` здесь ловит событие ДО того, как оно дойдёт до
     `<predictive-search>`, чей собственный слушатель висит на bubble.
     Сам файл `predictive-search.js` не трогаем — правило внутри него не
     меняется, просто событие до его слушателя в этом одном случае не
     доходит. */
  if (searchPanelContent && searchInputEl) {
    searchPanelContent.addEventListener('focusout', function (event) {
      if (!searchMobile.matches) return;
      if (event.target !== searchInputEl) return;
      if (!searchDetails || !searchDetails.hasAttribute('open')) return;
      if (!searchInputEl.value.length) return;
      var goingTo = event.relatedTarget;
      if (goingTo && goingTo !== document.body) return;
      event.stopPropagation();
    }, true);
  }
})();

